
import React from 'react';
import { Label } from '@/components/ui/label';

interface FilterSectionProps {
  id: string;
  label: string;
  children: React.ReactNode;
}

export const FilterSection: React.FC<FilterSectionProps> = ({ 
  id, 
  label, 
  children 
}) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      {children}
    </div>
  );
};
